import { render } from "./ComprehensiveReport.vue?vue&type=template&id=20cb4261"
import script from "./ComprehensiveReport.vue?vue&type=script&lang=js"
export * from "./ComprehensiveReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__